/**
 * Samsung Tizen CastingProvider — FOUNDATION + REQUIRES NATIVE RECEIVER.
 *
 * Browser SPAs cannot honestly discover/control Samsung Smart TVs without a
 * Tizen receiver (or Smart View companion path). Capability detection only.
 */

import { CastingCapabilityState } from "./CastingEvents";
import { CastPlatformReceiverRequirements } from "./CastReceiverContract";
import { createReceiverRequiredProvider } from "./createReceiverRequiredProvider";

export function createSamsungTVProvider(options) {
  var req = CastPlatformReceiverRequirements.samsung;
  return createReceiverRequiredProvider(
    {
      id: "samsung",
      displayName: "Samsung TV",
      capabilityState: CastingCapabilityState.REQUIRES_RECEIVER_APP,
      reason: req.mechanism,
      receiverContract: {
        appIdField: "samsungAppId",
        platform: "tizen",
        sessionModel: "CastReceiverSession",
        note: "Install branded Tizen app before marking operational.",
      },
    },
    options
  );
}

export default createSamsungTVProvider;
